import { Navigate, useLocation } from 'react-router-dom';

/** Preserves invite/join query params (e.g. `?next=`, `?ticket=`) on the combined auth screen. */
export function SignupRedirect() {
  const location = useLocation();
  return <Navigate to={`/login${location.search}${location.hash}`} replace />;
}
